import { Box, Button, ButtonProps } from "@mui/material";
import { Loader } from "bi-lib";

interface Props extends ButtonProps {
    isLoading: boolean;
}

export default function LoaderButton({ isLoading, ...buttonProps }: Props) {
    return (
        <Button
            disabled={isLoading}
            endIcon={
                isLoading ? (
                    <Box ml={1}>
                        <Loader size={20} padding={0} />
                    </Box>
                ) : undefined
            }
            {...buttonProps}
        >
            {buttonProps.children}
        </Button>
    );
}
